import { render, staticRenderFns } from "./ReferralView.vue?vue&type=template&id=b6bb16f4&scoped=true"
import script from "./ReferralView.vue?vue&type=script&lang=js"
export * from "./ReferralView.vue?vue&type=script&lang=js"
import style0 from "./ReferralView.vue?vue&type=style&index=0&id=b6bb16f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bb16f4",
  null
  
)

export default component.exports